import React from 'react'
import { Helmet } from 'react-helmet';

const PageContent = ({page}) => {

    const seoTitle = page?.seo?.title || `${page?.title} - Blackbough Swim`;

    return (
        <React.Fragment>
            <Helmet>
                <title>{seoTitle}</title>
                <meta name="description" content={page?.seo?.description} />
            </Helmet>

            <div className="max-container w-screen md:w-full space-y-5 pt-8 px-10">
                <h1 className='text-center my-8'>{page?.title}</h1>
                <div dangerouslySetInnerHTML={{ __html: page?.body }} />
            </div>
        </React.Fragment>
    );
}

export default PageContent;